document.addEventListener('turbo:load', () => {
  const run = document.getElementsByClassName('page-container analytics');

  if (run.length > 0) {
    const dateRange = document.querySelector('#range');
    const dateFormat = 'YYYY-MM-DD';

    dateRange.addEventListener('datesPicked', (event) => {
      const start = moment(event.detail.start).format(dateFormat);
      const end = moment(event.detail.end).format(dateFormat);

      const url = new URL(window.location.href);
      const baseUrl = url.origin + url.pathname;

      const searchParams = new URLSearchParams();

      searchParams.append('start', start);
      searchParams.append('end', end);

      if (url.searchParams.has('district_id')) {
        searchParams.append('district_id', url.searchParams.get('district_id'));
      }

      window.atlas.blockUI();

      window.location.href =  baseUrl + '?' + searchParams.toString();
    });
  }
});

